export class IntegrationColumn {
  name!: string;
  isIdentifier!: boolean;
}
